import { stringUtils } from '@verifime/utils';
import { TFromFieldInfo, TRules } from '@componentsroot/Form/FormGenerator/utils';

export type TFormFieldsAndRules<TFieldName = string> = {
  [rows: string]: TFromFieldInfo<TFieldName>[];
};

export function getFieldsRules<TFieldName = string>(
  formFieldsAndRules?: TFormFieldsAndRules<TFieldName>,
  prefix?: keyof typeof formFieldsAndRules,
): TRules {
  // TODO: processing prefix situation ?

  if (Object.keys(formFieldsAndRules || {}).length < 1) {
    return {};
  }

  const fieldsRules = {} as TRules;
  for (const [_, fieldsInfo] of Object.entries(formFieldsAndRules)) {
    fieldsInfo.forEach((fieldInfo) => {
      if (fieldInfo.renderType === 'DateRange') {
        for (const [_, value] of Object.entries(fieldInfo.dateRangeFieldsLabels)) {
          fieldsRules[stringUtils.generateCamelCaseString(String(fieldInfo.fieldName), value)] =
            fieldInfo.rules;
        }
      } else {
        fieldsRules[String(fieldInfo.fieldName)] = fieldInfo.rules;
      }
    });
  }
  return fieldsRules;
}

/**
 *
 * TODO: Rename it (delete _New suffix) once change to use new formfieldsAndRules generation
 */
export function getFieldsNamesFromFieldsAndRules(
  formFieldsAndRules?: TFormFieldsAndRules,
): string[] {
  const fieldsNameArray: string[] = [];
  if (!formFieldsAndRules) {
    return fieldsNameArray;
  }

  for (const [_, rowItems] of Object.entries(formFieldsAndRules)) {
    rowItems.forEach((item) => fieldsNameArray.push(item.fieldName));
  }
  return fieldsNameArray;
}

export function getFieldInfoByFieldName(
  fieldsAndRules: TFormFieldsAndRules,
  fieldName: string,
): TFromFieldInfo {
  if (Object.keys(fieldsAndRules || {}).length < 1) {
    return {} as TFromFieldInfo;
  }

  if (!fieldName) {
    return {} as TFromFieldInfo;
  }

  for (const [_, fieldsInfo] of Object.entries(fieldsAndRules)) {
    const foundFieldInfo = fieldsInfo.find((fieldInfo) => {
      if (fieldInfo.renderType === 'DateRange') {
        let foundDateRangeField = false;
        for (const [, labelValue] of Object.entries(fieldInfo.dateRangeFieldsLabels)) {
          if (stringUtils.generateCamelCaseString(fieldInfo.fieldName, labelValue) === fieldName) {
            foundDateRangeField = true;
            break;
          }
        }
        return foundDateRangeField;
      }
      return fieldInfo.fieldName === fieldName;
    });
    if (foundFieldInfo) {
      return foundFieldInfo;
    }
  }

  return {} as TFromFieldInfo;
}
